import React from 'react'
import AskDelaChatComponent from './AskDelaChatComponent'
import { ChatMessageStoreProvider } from './ChatMessageStoreProvider'
import { ChatInstanceId } from './useChatInstanceId'

/**
 * chatInstanceId - Used to identify the instances of the chat bot. Unique instance ids will have different sets of messages
 * Use `useChatInstanceId` to generate a Chat Instance Id if per user isolation is needed. Otherwise, you can craft your own.
 */
export interface AskDelaChatContainerProps {
    chatInstanceId: ChatInstanceId
}

const AskDelaChatContainer = ({
    chatInstanceId,
}: AskDelaChatContainerProps) => {
    return (
        <ChatMessageStoreProvider chatInstanceId={chatInstanceId.key}>
            <AskDelaChatComponent
                isOnHeader={chatInstanceId.key.includes('header')}
            />
        </ChatMessageStoreProvider>
    )
}

export default AskDelaChatContainer
